function AddressInput({
  address,
  city,
  province,
  postalCode,
  country,
  onChange,
}) {
  function handleFieldChange(event) {
    const { name, value } = event.target;

    onChange({
      address,
      city,
      province,
      postalCode,
      country,
      [name]: value,
    });
  }

  return (
    <>
      <div className="form-field registration-grid-full">
        <label htmlFor="profile-address">
          Address
        </label>

        <input
          id="profile-address"
          name="address"
          type="text"
          value={address}
          onChange={handleFieldChange}
          placeholder="Start typing your address"
          autoComplete="street-address"
        />

        <small className="form-helper-text">
          Address suggestions will be connected here.
        </small>
      </div>

      <div className="form-field">
        <label htmlFor="profile-city">
          City
        </label>

        <input
          id="profile-city"
          name="city"
          type="text"
          value={city}
          onChange={handleFieldChange}
          autoComplete="address-level2"
        />
      </div>

      <div className="form-field">
        <label htmlFor="profile-province">
          Province
        </label>

        <input
          id="profile-province"
          name="province"
          type="text"
          value={province}
          onChange={handleFieldChange}
          autoComplete="address-level1"
        />
      </div>

      <div className="form-field">
        <label htmlFor="profile-postal-code">
          Postal code
        </label>

        <input
          id="profile-postal-code"
          name="postalCode"
          type="text"
          value={postalCode}
          onChange={handleFieldChange}
          placeholder="A1A 1A1"
          autoComplete="postal-code"
        />
      </div>

      <div className="form-field">
        <label htmlFor="profile-country">
          Country *
        </label>

        <select
          id="profile-country"
          name="country"
          value={country}
          onChange={handleFieldChange}
          required
        >
          <option value="Canada">
            Canada
          </option>
        </select>
      </div>
    </>
  );
}

export default AddressInput;